// TV / lean-back device detection.
//
// Samsung Tizen 4.5 sends: Mozilla/5.0 (SMART-TV; Linux; Tizen 4.0.0.2) ...
// LG webOS sends:          Mozilla/5.0 (Web0S; Linux/SmartTV) ...
// Fire TV Silk sends:      Mozilla/5.0 (Linux; Android; AFTR ...) ... Silk/...
// Chromecast built-in:     ... CrKey/ ...
// Apple TV via Safari:     ... AppleTV5,3 ... (rare)
//
// We match all of the above so users on any Smart TV or connected-TV browser
// get the QR-code affordance and never hit a "browser not supported" wall.
const TV_UA_RE =
  /(smart-tv|SmartTV|SMART-TV|tizen|Web0S|WebOS|webos|Netcast|BRAVIA|CrKey|Silk|AFTS|AFTR|AFTB|AFTT|AFTM|AFTMM|Roku|HbbTV|Viera|VIERA|GoogleTV|AppleTV|POV_TV|Xbox|PlayStation|Nintendo|SHIELD Android TV)/i;

// The DRM-limited browsers that specifically can't play Spotify / Apple Music /
// most premium video web players. Superset of TV_UA_RE plus specific known
// gotcha builds.
const NO_DRM_RE = /(SmartTV|SMART-TV|Tizen|WebOS|Web0S|Netcast|BRAVIA|CrKey|AFTS|AFTR|AFTB|AFTT|AFTM|Roku|HbbTV|VIERA|Viera|Xbox|PlayStation|Nintendo)/i;

export function isTvBrowser() {
  if (typeof navigator === "undefined") return false;
  return TV_UA_RE.test(navigator.userAgent || "");
}

export function lacksDrm() {
  if (typeof navigator === "undefined") return false;
  return NO_DRM_RE.test(navigator.userAgent || "");
}

/**
 * Called once at app boot. Adds `tv-mode` class on <body> so CSS can serve
 * always-on focus rings + larger targets for D-pad users. Also sets a
 * `no-drm` class so we can style / swap Spotify links proactively.
 */
export function installTvModeClass() {
  if (typeof document === "undefined") return;
  const body = document.body;
  if (!body) return;
  if (isTvBrowser()) body.classList.add("tv-mode");
  if (lacksDrm()) body.classList.add("no-drm");
}
